import BuiltInFunction from "./BuiltInFunction";

export default BuiltInFunction;
